export const validateCreateInventory = ({ name, quantity, rate, costPrice, description }: any) => {
  const errors = {
    name: '',
    quantity: '',
    rate: '',
    costPrice: '',
    description: '',
  };
  if (!name) {
    errors.name = 'Inventory Name is required';
  }
  if (isNaN(quantity) || quantity === 0) {
    if (isNaN(quantity)) errors.quantity = 'Quantity is required';
    else errors.quantity = 'Enter a value greater than zero';
  }
  if (isNaN(rate) || rate === 0) {
    if (isNaN(rate)) errors.rate = 'Selling Price is required';
    else errors.rate = 'Enter a value greater than zero';
  }
  if (isNaN(costPrice) || costPrice === 0) {
    if (isNaN(costPrice)) errors.costPrice = 'Cost Price is required';
    else errors.costPrice = 'Enter a value greater than zero';
  }

  // Check if any error messages are present
  const hasErrors = Object.values(errors).some((error) => error !== '');

  return { hasErrors, errors };
};

export const validateRestock = ({ rate, quantity, costPrice }: any) => {
  const errors = {
    quantity: '',
    rate: '',
    costPrice: '',
  };

  if (isNaN(quantity) || quantity === 0) {
    if (isNaN(quantity)) errors.quantity = 'Quantity is required';
    else errors.quantity = 'Enter a value greater than zero';
  }
  if (isNaN(rate) || rate === 0) {
    if (isNaN(rate)) errors.rate = 'Selling Price is required';
    else errors.rate = 'Enter a value greater than zero';
  }
  if (isNaN(costPrice) || costPrice === 0) {
    if (isNaN(costPrice)) errors.costPrice = 'Cost Price is required';
    else errors.costPrice = 'Enter a value greater than zero';
  }

  // Check if any error messages are present
  const hasErrors = Object.values(errors).some((error) => error !== '');

  return { hasErrors, errors };
};
export const validateEdit = ({ name, description }: any) => {
  const errors = {
    name: '',
    description: '',
  };

  if (!name) {
    errors.name = 'Inventory Name is required';
  }
  if (!description) {
    errors.description = 'Description is required';
  }

  // Check if any error messages are present
  const hasErrors = Object.values(errors).some((error) => error !== '');

  return { hasErrors, errors };
};

export const ValidateVariation = (variations: any) => {
  const data = [...variations];
  let errorMsg = [];

  for (let index = 0; index < data.length; index++) {
    let valid = true;
    let error = {
      type: '',
      costPrice: '',
      price: '',
      quantity: '',
    };

    // type
    if (!data[index].type) {
      error.type = 'type is required';
      valid = false;
    } else {
      error.type = '';
    }

    // Cost Price
    if (isNaN(data[index].costPrice)) {
      error.costPrice = 'cost price is required';
      valid = false;
    } else if (data[index].costPrice === 0) {
      error.costPrice = 'cost price must be greater than zero';
      valid = false;
    } else {
      error.costPrice = '';
    }

    // Selling Price
    if (isNaN(data[index].price)) {
      error.price = 'cost price required';
      valid = false;
    } else if (data[index].price === 0) {
      error.price = 'cost price must be greater than zero';
      valid = false;
    } else {
      error.price = '';
    }

    // Quantity
    if (isNaN(data[index].quantity)) {
      error.quantity = 'quantity required';
      valid = false;
    } else if (data[index].quantity === 0) {
      error.quantity = 'quantity must be greater than zero';
      valid = false;
    } else {
      error.quantity = '';
    }
    errorMsg.push(error)
  }
  return errorMsg
};
